import { Link } from '@tanstack/react-router';
import { webVersion } from '../build-info';
import { useSignOut } from '../features/auth/useSignOut';
import { HealthCard } from '../features/health/HealthCard';
import { SpikeLink } from '../features/spike/SpikeLink';

export function HomePage() {
  const signOut = useSignOut();
  return (
    <main className="page">
      <h1>Hello, Personal OS</h1>
      <p className="version">
        Version <span data-testid="web-version">{webVersion}</span>
      </p>
      <HealthCard />
      <SpikeLink />
      <nav className="home-links" aria-label="Pages">
        <Link to="/scratch">Scratch notes</Link>
        <Link to="/history">History</Link>
      </nav>
      <p className="account-links" data-testid="signed-in">
        Signed in. <Link to="/account">Account</Link>{' '}
        <button type="button" className="link" onClick={() => void signOut(false)}>
          Sign out
        </button>
      </p>
    </main>
  );
}
